import type { AnalyticsObject, AnalyticsProperties } from '../types'

export class ImtSearchModal implements AnalyticsObject {
  name: string
  properties: ImtSearchModalProperties
  constructor(properties: ImtSearchModalProperties) {
    this.name = 'IMT Search Modal'
    this.properties = properties
  }
}

export interface ImtSearchModalProperties extends AnalyticsProperties {
  imtSearchModal: {
    linkLabel: string
    sectionId?: string
    sliceType?: string
    sliceTitle?: string
  }
}
